<script>
export default {
  page: {
    title: 'Puslapis kraunasi...',
  },
}
</script>

<template>
  <div class="flex flex-1 items-center justify-center">
    <Transition appear>
      <font-awesome-icon
        :icon="['fas', 'spinner']"
        spin
        class="text-6xl text-gray-500"
      />
    </Transition>
  </div>
</template>
